import { TableCols } from "../interfaces/static-data";

export const ListingVenueColumns: TableCols[] = [
    {
        key: 'longName',
        displayValue: 'Long Name'
    },
    {
        key: 'shortName',
        displayValue: 'Short Name'
    },
    {
        key: 'description',
        displayValue: 'Description'
    },
    {
        key: 'website',
        displayValue: 'Website'
    },
    {
        key: 'regulated',
        displayValue: 'Regulated',
        type: 'boolean',
        items: [
            {
                id: true,
                displayValue: 'Yes'
            },
            {
                id: false,
                displayValue: 'No'
            }
        ]
    },
    {
        key: 'micCode',
        displayValue: 'MIC Code'
    },
];